import React, { useState } from 'react';
import PageShell from '../ui/PageShell';
import Button from '../ui/Button';
import Footer from '../Footer';
import apiService from '../../services/ApiService';

const UnsubscribePage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  return (
    <PageShell>
      <div className="max-w-md mx-auto px-4 py-16">
        <h1 className="font-display text-3xl text-white font-semibold">Email preferences</h1>
        <p className="mt-2 text-sm text-gray-400">
          Marketing messages can be turned off here. You will still receive required account and purchase messages.
        </p>
        <form
          className="mt-6 space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            void apiService
              .submitPrivacyRequest({
                request_type: 'marketing_opt_out',
                contact_email: email.trim(),
                message: 'Marketing unsubscribe',
              })
              .then(() => setMessage('Your marketing opt-out request was recorded.'));
          }}
        >
          <label className="block">
            <span className="input-label">Email</span>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <Button type="submit" variant="primary" className="w-full min-h-[44px]">
            Unsubscribe from marketing
          </Button>
        </form>
        {message ? (
          <p className="mt-4 text-sm text-emerald-300" role="status">
            {message}
          </p>
        ) : null}
      </div>
      <Footer />
    </PageShell>
  );
};

export default UnsubscribePage;
